import React, { memo, useEffect, useState, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import classNames from 'classnames';
// import { geAppRecommend } from '../../actions/detail';
import { getAAppGroup } from '../../actions/adetail';
import { logging } from '../../actions/log';
import ASoftCard from '../../components/ASoftCard/ASoftCard';
import SoftCard from '../../components/SoftCard/SoftCard';
import { sortSoftsByLocalSoftInit } from '../../utils/utils';
import styles from './SoftRecommend.module.less';
import CardIndex from '../../card/CardIndex/CardIndex';
import { useInView } from 'react-intersection-observer';
import config from './config';

const selectAppRecommend = createSelector(
  state => state.detail,
  detail => detail.appRecommend,
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectLocalSoftsInit = createSelector(
  state => state.native,
  native => native.installedSoftInit,
);
const selectGroups = createSelector(
  state => state.adetail,
  adetail => adetail.detailGroups,
);

export default memo(({ softDetails }) => {
  const dispatch = useDispatch();
  // const appRecommendData = useSelector(selectAppRecommend);
  const [appRecommendData, setAppRecommendData] = useState(null);
  const logInfoData = useSelector(selectLogInfo);
  const localSoftsInit = useSelector(selectLocalSoftsInit);

  const [allSofts, setAllSofts] = useState([]);
  const [showSofts, setShowSofts] = useState([]);
  const [showPage, setShowPage] = useState(0);
  // const groupsData = useSelector(selectGroups);
  const [groupsData, setGroupsData] = useState(null);
  const recommendRef = useRef();

  const [ref, inView] = useInView({
    threshold: 1,
  });

  // 由于宽度可以变化，所以通过宽度计算每一页的个数
  const getPageSize = useCallback(() => {
    let pageSize = 3;
    if (recommendRef && recommendRef.current && recommendRef.current.offsetWidth) {
      pageSize = parseInt(recommendRef.current.offsetWidth / 250);
      if (pageSize > 2) {
        return pageSize * 3;
      }
    }
    return pageSize * 3;
  }, [recommendRef]);

  /**
   * 每一次change 都是数组中循环展示6个  不够就用数组前面的应用组装成6个  这样依次循环展示
   * 根据保存的页码数，获取当前应该展示的6个应用
   */
  const getAppsByPage = useCallback((allSofts_ = [], showPage_ = 1) => {
    let pageSize = getPageSize();
    if (allSofts_ && allSofts_.length < 9) {
      pageSize = 3;
    }
    if (allSofts_ && allSofts_.length === 0) {
      return [];
    }
    let softArrLoop = allSofts_;
    while (showPage_ * pageSize > softArrLoop.length) {
      softArrLoop = softArrLoop.concat(allSofts_);
    }
    return softArrLoop.slice((showPage_ - 1) * pageSize, showPage_ * pageSize);
  }, []);

  const handleUpdate = useCallback(
    (allSofts_, showPage_) => {
      setShowPage(showPage_ + 1);
      setShowSofts(getAppsByPage(allSofts_, showPage_ + 1));

      // 按钮点击打桩
      if (showPage_ > 0) {
        dispatch(
          logging({
            category: 'C',
            action: 'Reco_Change',
            label: '',
            param2: {
              source: 'AppDetail',
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              softid: softDetails.packageName,
              packageName: softDetails.packageName,
              versionCode: softDetails.versionCode,
              softType: '1',
            },
          }),
        );
      }
    },
    [dispatch, logInfoData],
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    try {
      const data = await config.geAppRecommend({
        softInfo: softDetails.packageName,
        androidType: softDetails.androidType || 0,
        source: `AppDetail_Reco||${softDetails.softID}`,
      });
      setAppRecommendData(data);
    } catch (err) {}
  }, [dispatch, softDetails]);

  useEffect(() => {
    if (
      appRecommendData &&
      appRecommendData.softInfo === softDetails.packageName &&
      appRecommendData.apps &&
      appRecommendData.apps.length > 0
    ) {
      const allSofts_ = sortSoftsByLocalSoftInit(appRecommendData.apps || [], localSoftsInit);
      setAllSofts(allSofts_);
      handleUpdate(allSofts_, 0);
    }
  }, [dispatch, appRecommendData, localSoftsInit]);

  useEffect(async () => {
    try {
      const data = await config.getAAppGroup({
        pageType: 'anDetail',
        ztType: softDetails.softType,
      });
      setGroupsData(data);
    } catch (err) {}
  }, []);

  const changView = content => {
    dispatch(
      logging({
        category: 'I',
        action: 'anDetail_Reco_Content_Show',
        label: '',
        param2: {
          source: `anDetail_Reco||${softDetails.packageName}`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          ...content,
        },
      }),
    );
  };

  useEffect(() => {
    if (inView) {
      changView({
        code: appRecommendData.code,
        pageCardTitle: appRecommendData.desc,
      });
    }
  }, [inView, appRecommendData]);

  return (
    <div>
      {/* 专题推荐 */}
      <div className={styles.comm_groups}>
        {/* group */}
        {groupsData &&
          groupsData.dataList &&
          groupsData.dataList.length > 0 &&
          groupsData.pageType === 'anDetail' &&
          groupsData.dataList.map((item, i) => (
            <CardIndex
              data={{
                ...item,
                pageType: groupsData.pageType,
                ztType: softDetails.softType || 'all',
              }}
              key={i}
              logInfo={{ tag: 'ADetail', changView }}
            />
          ))}
      </div>
      {/* 相关推荐 */}
      {showSofts && showSofts.length > 0 && (
        <div className={styles.detail_recommend} ref={ref} id="detail_soft_recommend">
          <div className={styles.detail_recommend_header}>
            <div className={styles.detail_recommend_title}>相关推荐</div>
            <div
              className={styles.detail_recommend_more}
              onClick={() => {
                handleUpdate(allSofts, showPage);
              }}
            >
              <i className={classNames(styles.refresh_icon, 'iconfont icon-refresh1')} />
              <span>换一换</span>
            </div>
          </div>
          <div className={styles.detail_recommend_softs}>
            {showSofts.map((soft, j) =>
              soft.androidType === '1' ? (
                <ASoftCard
                  soft={soft}
                  logInfo={{ source: `AppDetail_Reco||${softDetails.softID}` }}
                  key={j}
                />
              ) : (
                <SoftCard
                  soft={soft}
                  logInfo={{ source: `AppDetail_Reco||${softDetails.softID}` }}
                  key={j}
                />
              ),
            )}
          </div>
        </div>
      )}
    </div>
  );
});
